import { render, staticRenderFns } from "./newPeople.vue?vue&type=template&id=2a790ca5&scoped=true&"
import script from "./newPeople.vue?vue&type=script&lang=js&"
export * from "./newPeople.vue?vue&type=script&lang=js&"
import style0 from "./newPeople.vue?vue&type=style&index=0&id=2a790ca5&prod&lang=css&"
import style1 from "./newPeople.vue?vue&type=style&index=1&id=2a790ca5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a790ca5",
  null
  
)

export default component.exports